import * as React from 'react';
import { Button } from '@mui/material';

export default function Primary(props:any) {
    return (
        <Button
        color="primary"
        variant="contained"
        {...props}
      >
        {props.title}
      </Button>
    )
}




